type JSONCompany = {
  company_name?: string;
  website?: string;
  email?: string;
  twitter?: string;
  facebook?: string;
  instagram?: string;
  unsupported_store?: string;
  brand_primary_color?: string;
  brand_secondary_color?: string;
  reply_to_email?: string;
};

type Company = {
  companyName?: string;
  website?: string;
  email?: string;
  twitter?: string;
  facebook?: string;
  instagram?: string;
  unsupportedStore?: string;
  brandPrimaryColor?: string;
  brandSecondaryColor?: string;
  replyToEmail?: string;
};

function toJSON(company: Company): JSONCompany {
  return {
    company_name: company.companyName ? company.companyName : '',
    website: company.website ? company.website : '',
    email: company.email ? company.email : '',
    twitter: company.twitter ? extractHandler(company.twitter) : '',
    facebook: company.facebook ? extractHandler(company.facebook) : '',
    instagram: company.instagram ? extractHandler(company.instagram) : '',
    brand_primary_color: company.brandPrimaryColor ?? '',
    brand_secondary_color: company.brandSecondaryColor ?? '',
    reply_to_email: company.replyToEmail ?? '',
  };
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function fromJSON(data: JSONCompany): Company {
  return {
    companyName: data.company_name,
    website: data.website,
    email: data.email,
    twitter: data.twitter,
    facebook: data.facebook,
    instagram: data.instagram,
    unsupportedStore: data.unsupported_store,
    brandPrimaryColor: data.brand_primary_color,
    brandSecondaryColor: data.brand_secondary_color,
    replyToEmail: data.reply_to_email,
  };
}

export function extractHandler(url: string) {
  const splitted = url.split('/');
  return splitted.pop() || splitted.pop(); // deals with trailing slash;
}

export default Company;

export { Company, JSONCompany, toJSON, fromJSON };
